import {LOGIN_HOST} from '../../../../config/constants';
import {LoginService} from './LoginService';

export const getLoginServiceForApp = () => new LoginService(LOGIN_HOST);
